<template>
    <div style="display: flex;flex-direction: column;
    height: 100%;
    ">
        <div style="width: calc(100% - 40px);position: fixed;top: 0;left: 0;display: flex;flex-direction: column;padding: 20px;"
            :style="{
                height: (searchBarHeight - 40) + 'px',
                background: 'url(' + require('../assets/contentListBG.jpeg') + ') center'
            }">
            <div style="display: flex;align-items: center;font-weight: 700;">
                <div style="display: flex;align-items: center;">
                    < {{ typeName }} </div>
                        <div style="display: flex;align-items: center;margin-left: 10px;">
                            <img style="width: 20px;height: 20px;" src="../assets/定位1.png" alt="">
                            <div style="margin-left: 5px;">肇庆市</div>
                        </div>
                </div>
                <el-autocomplete style="margin-top: 10px;" class="inline-input" v-model="inputForSearch"
                    :fetch-suggestions="querySearchAsync" placeholder="请输入内容" :trigger-on-focus="false"
                    @select="handleSelect"></el-autocomplete>
            </div>
            <div :style="{ height: contentHeight + 'px', marginTop: searchBarHeight + 'px' }" style="width: 100%;overflow: auto;scrollbar-width: none;
  -ms-overflow-style: none;display: flex;align-items: center; ">
                <div class="columnformat" id="columnformat">
                    <div v-for="item, index in companyList" :key="index" @click="seeCompanyDetail(item.id)"
                        style="display: flex;width:calc(100% - 20px);padding: 10px;flex-direction: column;background: white;">
                        <div style="display: flex;width: 100%;">
                            <img style="width: 80px;height: 80px;object-fit:cover;background: black;border-radius: 10px;"
                                :src="resourceBase + '/assets/companyImg/' + item.companyIcon" alt="">
                            <div
                                style="flex: 1;height: 100%;display: flex;flex-direction: column;padding: 0px 5px 0px 5px;overflow: hidden;">
                                <div style="width: 100%;display: flex;justify-content: space-between;">
                                    <div style="font-weight: 700;font-size: large;">{{ item.companyName }}</div>
                                    <div style="display: flex;">
                                        <div style="background: blue;color: white;padding: 2px;border-radius: 5px;">到店
                                        </div>
                                        <div
                                            style="background: #EA9518;color: black;margin-left: 10px;padding: 2px;border-radius: 5px;color: white;">
                                            上门
                                        </div>
                                    </div>
                                </div>
                                <div style="width: 100%;display: flex;align-items: center;">
                                    <img src="../assets/五角星.png" style="width: 15px;height: 15px;" alt="">
                                    <div style="margin-left: 5px;line-height: 25px;color: #EA9518;font-weight: 700;">{{
                                        item.rating }}</div>
                                    <div style="margin-left: 5px;line-height: 25px;">{{ item.commentNum }}条评论</div>
                                </div>
                                <div v-if="item.businessScope != null"
                                    style="width: 100%;display: flex;align-items: center;overflow: auto;margin: 5px 0px; -ms-overflow-style: none; scrollbar-width: none;">
                                    <div v-for="businessScope, businessIndex in item.businessScope.split(';')"
                                        :key="businessIndex"
                                        style="margin-right: 10px;background: #f0f0f0;color: #333;padding: 2px 5px;border-radius: 3px;font-size: small;flex-shrink: 0;">
                                        {{ businessScope }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="width: 100%;display: flex;flex-direction: column;">
                            <div v-for="recommendItem, recommendItemIndex in item.recommendItems"
                                :key="recommendItemIndex"
                                style="margin-top: 5px;width: 100%;display: flex;align-items: center;">


                                <div style="width: 80px;display: flex;align-items: center;justify-content: end;">
                                    <div
                                        style="border-radius: 5px;border: solid 1px #EA9518;color: #EA9518;font-size: small;padding: 2px 5px;">
                                        {{ recommendItem.discount }}折
                                    </div>
                                </div>
                                <div
                                    style="flex: 1;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display: block;text-align: left; ">
                                    {{ recommendItem.itemName }}</div>
                                <div style="height: 100%;color: grey;">已售{{ recommendItem.itemSales }}</div>

                            </div>
                        </div>

                    </div>
                    <div style="width: 100%;margin: 20px 0;" :style="{
                        height: $store.state.indexBarHeight + 10 + 'px'
                    }">
                        <a href="https://beian.miit.gov.cn/" target="_blank">ICP备案号</a>
                        <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2026080515号-2</a>
                    </div>
                </div>

            </div>

        </div>
</template>

<script>
import { mapState } from 'vuex';
import request from "../axios/request";
export default {
    computed: {
        ...mapState(['typeName'])
    },
    data() {
        return {
            contentHeight: null,
            resourceIp: null,
            resourceBase: /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname) ? 'https://yuanhuihuanhuan.com' : window.location.origin,
            companyList: [],
            searchBarHeight: 110,
            inputForSearch: "",
            typeId: null
        }
    },
    mounted() {
        this.typeId = this.$route.params.type;

        const resizeObserver = new ResizeObserver((entries) => {
            requestAnimationFrame(() => {
                for (const entry of entries) {
                    this.contentHeight = window.innerHeight - this.$store.state.indexBarHeight
                }
            });
        });
        resizeObserver.observe(document.getElementById("columnformat"));
        this.resourceIp = this.extractIPFromURL(window.location.origin);
        this.getCompanyList()
    },
    methods: {

        handleSelect() { },
        async querySearchAsync(queryString, cb) {
            let res = await request({
                url: "/company/api/getCompanyListByInput?name=" + queryString,
                method: "GET"
            })
            if (res.data.status == 200) {
                let companyList = res.data.data
                let result = companyList.map(company => {
                    return { value: company.companyName }
                })
                cb(result);
            } else {
                cb([]);
            }
        },
        seeCompanyDetail(id) {
            this.$router.push({
                path: '/CompanyDetail/' + id
            })
        },
        extractIPFromURL(url) {
            try {
                // 方法1：优先使用浏览器原生URL对象解析（兼容现代浏览器）
                const parsedUrl = new URL(url);
                const hostname = parsedUrl.hostname;

                // 如果是IPv6地址（如[2001:db8::1]），去除方括号
                if (hostname.startsWith('[') && hostname.endsWith(']')) {
                    return hostname.slice(1, -1);
                }

                // 如果是IPv4地址或域名，直接返回
                return hostname;
            } catch (e) {
                // 方法2：URL对象解析失败时，使用正则表达式作为兜底方案
                const ipv4Regex = /(?:\d{1,3}\.){3}\d{1,3}/; // 匹配IPv4
                const domainRegex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/i; // 匹配域名[1,4](@ref)

                // 尝试匹配IPv4
                const ipMatch = url.match(ipv4Regex);
                if (ipMatch) return ipMatch[0];

                // 尝试匹配域名
                const domainMatch = url.match(domainRegex);
                if (domainMatch && domainMatch[1]) {
                    return domainMatch[1].replace(/^www\./, ''); // 可选：去除www前缀
                }

                return null; // 均未匹配时返回null
            }
        },
        async getCompanyList() {
            let res = await request({
                url: "/company/api/getCompanyListByTypeId?typeId=" + this.typeId,
                method: "GET"
            })
            if (res.data.status == 200) {
                this.companyList = res.data.data
            }
        }
    }
}
</script>

<style scoped>
.columnformat {

    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #F0F5F4;
    overflow: auto;
}
</style>
